module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/stylePanel/deleteline-01e63c.svg";